import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import PageTitle from './pageTitle';

export default function NotFound() {

    useEffect(() => {
        PageTitle("NOT_FOUND");
    }, []);

    return (
        <Box height={'80vh'} width={'100%'} textAlign={'center'}>
            <Typography color={'red'} fontSize={60} marginTop={10}>
                &#9888; 404
            </Typography>
            <Typography color={'gray'} fontSize={36}>
                Page Not Found
            </Typography>
        </Box>
    )
}
